import type { ProgramDetails } from '@/modules/Entertainment/interface/Program';
import { useState, type FC } from 'react';
import {
  BookmarkAddOutline,
  BookmarkRemoveOutline,
} from '@eqi-investimentos/icons/web';
import { Button, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { useBookmark } from '@/modules/Entertainment/http/client/mutations/useBookmark';

export const SaveButton: FC<SaveButtonProps> = ({
  id,
  object,
  bookmarked,
  handleBookmark,
}) => {
  const [isBookmarked, setIsBookmarked] = useState(bookmarked);
  const t = useT();
  const { mutate, isPending } = useBookmark(['last', 'content']);

  return (
    <Button
      aria-label={isBookmarked ? t('attributes.saved') : t('attributes.save')}
      rightIcon={
        isBookmarked ? <BookmarkRemoveOutline /> : <BookmarkAddOutline />
      }
      gap="2xs"
      variant="naked"
      color="content.brand"
      isLoading={isPending}
      onClick={() =>
        handleBookmark
          ? handleBookmark()
          : mutate(
              { id, bookmarked: isBookmarked, object },
              { onSuccess: () => setIsBookmarked((prev) => !prev) }
            )
      }
    >
      <Text size="label.xl" fontWeight="semibold">
        {isBookmarked ? t('attributes.saved') : t('attributes.save')}
      </Text>
    </Button>
  );
};

export type SaveButtonProps = Pick<ProgramDetails, 'bookmarked'> &
  (
    | {
        id?: never;
        object?: never;
        handleBookmark: () => void;
      }
    | (Pick<ProgramDetails, 'id' | 'object'> & {
        handleBookmark?: never;
      })
  );
